import type { PropertyDetailsFragment } from '__generated__/athena';

/**
 * Determines if a property is eligible for buy-direct features. Property must
 * have BUY_DIRECT_ELIGIBLE tag (set by backend based on BUY_DIRECT_MARKETS).
 *
 * @param property - The property to check
 * @returns true if buy-direct features should be shown for this property
 */
export const isBuyDirectEligible = (property: PropertyDetailsFragment): boolean => {
  // Market gate (respects BUY_DIRECT_MARKETS from backend)
  return property.listingTags?.includes('BUY_DIRECT_ELIGIBLE') ?? false;
};
